export const getPaymentTableHeaders = (useDollars) => ({
  select: "SELECCIONAR",
  importer: "IMPORTADOR",
  volante: "Nº DE VOLANTE",
  paymentType: "TIPO DE PAGO",
  status: "NRO DAM",
  retirement: "RETIRO",
  rucId: "RAZÓN SOCIAL AGENTE ADUANERO",
  electronicFacNum: "NRO DE SERIE",
  amount: `MONTO (${useDollars ? "DÓLARES" : "SOLES"})`,
  exportPdf: "EXPORTAR A PDF",
  actions: "ACCIONES",
});

export const ITEMS_PER_PAGE = 8;

export const PAYMENT_TABLE_MODAL_STATES = {
  disabled: 0,
  paymentComment: 1,
  paymentDeletion: 2,
  comment: 3,
};
